const Consts = {
  ServiceName: 'みんなの契約書',
  BasicPlanPrice: 19800,
  OptionPlanPrice: 3000,
  MaxUploadFileSize: 20 * 1024 * 1024,
  MaxUploadFileSizeMB: 20,
  TextParamMaxLength: 1000,
  Role: {
    LegalManager: 'legalManager',
    LegalStaff: 'legalStaff',
    BusinessManager: 'businessManager',
    BusinessStaff: 'businessStaff',
    BusinessStampOnly: 'businessStampOnly',
    BusinessAdmin: 'businessAdmin',
    BusinessGroupManager: 'businessGroupManager',
  },
  DocxContentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  HelpUrl: 'https://minnano-keiyakusho.jp/help',
}

export default Consts
